import { BaseAsyncValue } from '../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { getOneClicHaulersSelected } from '@ordersnproducts/modules/one-click-order/selectors/one-click-haulers.selector';

export class OneClickHaulerProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClicHaulersSelected).pipe(
      filter(hauler => !!hauler),
      map(hauler => {
        return `${hauler.haulerDesc}`;
      }),
    );
  }
}
